// Ports ContactView from Rev9 Site.html.

/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';

import { Honeypot, TurnstileWidget } from '../../lib/turnstile';

import { MarketingLayout } from '../../components/marketing-shell';
import { api } from '../../lib/api';

export default function Contact() {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', entity: '', message: '', website: '', cf_turnstile_response: '' });
  const set = (k: string) => (e: any) => setForm(f => ({ ...f, [k]: e.target.value }));

  const submit = async (e: any) => {
    e.preventDefault();
    setError(null); setBusy(true);
    try {
      await api('/contact-public', { method: 'POST', body: form });
      setSent(true);
      setForm({ name: '', email: '', entity: '', message: '', website: '', cf_turnstile_response: '' });
    } catch (err: any) {
      setError(err?.payload?.detail || 'Could not send. Please email desk@rev9.capital.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <MarketingLayout>
      <main className="view">
        <section style={{ padding: '120px 0 var(--pad-y)' }}>
          <div className="container">
            <div className="section-head">
              <span className="kicker">04 · CONTACT</span>
              <h1 className="section-title">For inquiries about <em>managed accounts</em> at Rev9 Capital.</h1>
            </div>

            <div className="contact-grid">
              <form onSubmit={submit}>
                <div className="field">
                  <label className="field-label">NAME</label>
                  <input className="field-input" required placeholder="Your name" value={form.name} onChange={set('name')} />
                </div>
                <div className="field">
                  <label className="field-label">EMAIL</label>
                  <input className="field-input" type="email" required placeholder="you@firm.example" value={form.email} onChange={set('email')} />
                </div>
                <div className="field">
                  <label className="field-label">ENTITY (optional)</label>
                  <input className="field-input" placeholder="Fund, family office, or company" value={form.entity} onChange={set('entity')} />
                </div>
                <div className="field">
                  <label className="field-label">MESSAGE</label>
                  <textarea className="field-input" required placeholder="Briefly: what brings you to Rev9?" value={form.message} onChange={set('message')} />
                </div>
                {/* Honeypot — hidden from humans, bots fill it. */}
                <Honeypot value={form.website} onChange={v => setForm(f => ({ ...f, website: v }))} />
                <TurnstileWidget onToken={t => setForm(f => ({ ...f, cf_turnstile_response: t }))} />
                <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginTop: 8 }}>
                  <button type="submit" className="btn" disabled={busy}>
                    {busy ? 'Sending…' : <>Send <span className="btn-arrow">→</span></>}
                  </button>
                  {sent && (
                    <span style={{ fontFamily: 'var(--serif)', fontStyle: 'italic', color: 'var(--accent)', fontSize: 18 }}>
                      Received. The desk will respond directly.
                    </span>
                  )}
                  {error && (
                    <span style={{ fontFamily: 'var(--serif)', fontStyle: 'italic', color: 'var(--oxblood)', fontSize: 16 }}>
                      {error}
                    </span>
                  )}
                </div>
              </form>

              <aside style={{ padding: 40, border: '1px solid var(--ink)', background: 'var(--tint)', alignSelf: 'start' }}>
                <span className="kicker">DIRECT LINE</span>
                <div style={{
                  fontFamily: 'var(--serif)', fontStyle: 'italic', fontWeight: 300,
                  fontSize: 28, margin: '16px 0 28px', color: 'var(--accent)',
                }}>
                  desk@rev9.capital
                </div>
                <hr style={{ border: 0, borderTop: 'var(--hairline)', margin: '20px 0' }} />
                <span className="kicker">OFFICE</span>
                <div style={{ fontFamily: 'var(--serif)', fontSize: 17, marginTop: 12 }}>
                  Rev9 Capital LLC<br />
                  <span style={{ color: 'var(--ink-3)' }}>Miami, Florida</span><br />
                  <span style={{ color: 'var(--ink-3)' }}>United States</span>
                </div>
                <hr style={{ border: 0, borderTop: 'var(--hairline)', margin: '20px 0' }} />
                <span className="kicker">PROCESS</span>
                <p style={{
                  fontFamily: 'var(--serif)', fontSize: 15, lineHeight: 1.5,
                  margin: '12px 0 0', color: 'var(--ink-2)',
                }}>
                  Inquiries are reviewed within two business days. We accept new mandates quarterly, subject to capacity.
                </p>
              </aside>
            </div>
          </div>
        </section>
      </main>
    </MarketingLayout>
  );
}
